var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 282.366,
    height: 37.393,
    viewBox: "0 0 282.366 37.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1242",
    "data-name": "Rectangle 1242",
    width: 282.366,
    height: 37.393,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2475",
    "data-name": "Group 2475",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M56.9.5V19.088H68.691V16.05H60.084V.5Z",
    transform: "translate(-15.746 -0.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2474",
    "data-name": "Group 2474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2473",
    "data-name": "Group 2473",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M74.7,15.69V12.942C74.7,9.47,76.8,7.3,80.559,7.3c3.833,0,5.858,2.17,5.858,5.642V15.69c0,3.472-2.1,5.642-5.858,5.642S74.7,19.162,74.7,15.69m8.607-.145V13.014c0-1.881-.868-2.893-2.748-2.893s-2.748,1.013-2.748,2.893v2.531c0,1.881.868,2.893,2.748,2.893s2.748-1.013,2.748-2.893",
    transform: "translate(-20.672 -2.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M105.546,13.231V20.97h-3.11V13.158c0-2.025-1.085-3.038-2.676-3.038a2.578,2.578,0,0,0-2.748,2.6V20.97H93.9V7.662h2.025L96.5,8.819A5.574,5.574,0,0,1,100.483,7.3c3.11,0,5.063,1.736,5.063,5.931",
    transform: "translate(-25.985 -2.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M124.618.5V19.088h-2.1l-.506-1.013a5.536,5.536,0,0,1-3.906,1.447c-3.255,0-5.208-1.664-5.208-5.569V11.132c0-3.978,2.025-5.569,5.208-5.569a5.276,5.276,0,0,1,3.4,1.013V.717h3.11Zm-3.11,13.67V10.626a2.505,2.505,0,0,0-2.821-2.314c-1.736,0-2.748.868-2.748,2.821v2.531c0,1.953,1.013,2.821,2.748,2.821a2.5,2.5,0,0,0,2.821-2.314",
    transform: "translate(-31.243 -0.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M132,15.69V12.942c0-3.472,2.1-5.642,5.858-5.642,3.833,0,5.859,2.17,5.859,5.642V15.69c0,3.472-2.1,5.642-5.859,5.642-3.689,0-5.858-2.17-5.858-5.642m8.679-.145V13.014c0-1.881-.868-2.893-2.748-2.893s-2.748,1.013-2.748,2.893v2.531c0,1.881.868,2.893,2.748,2.893s2.748-1.013,2.748-2.893",
    transform: "translate(-36.529 -2.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M162.946,13.231V20.97h-3.11V13.158c0-2.025-1.085-3.038-2.676-3.038a2.578,2.578,0,0,0-2.748,2.6V20.97H151.3V7.662h2.025l.579,1.157A5.574,5.574,0,0,1,157.883,7.3c3.11,0,5.063,1.736,5.063,5.931",
    transform: "translate(-41.869 -2.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M193.832,6.431v6.726c0,3.616-2.676,5.858-7.016,5.858H179.8V.5h6.943c4.484,0,7.088,2.314,7.088,5.931m-3.182.145c0-1.953-1.23-3.11-3.616-3.11h-3.978V16.05h3.978c2.387,0,3.616-1.157,3.616-3.11Z",
    transform: "translate(-49.756 -0.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M201.7,15.59V12.842c0-3.472,2.1-5.642,5.858-5.642,3.833,0,5.858,2.17,5.858,5.642V15.59c0,3.472-2.1,5.642-5.858,5.642-3.761.072-5.858-2.1-5.858-5.642m8.679-.072V12.986c0-1.881-.868-2.893-2.748-2.893s-2.748,1.013-2.748,2.893v2.531c0,1.881.868,2.893,2.748,2.893s2.748-1.013,2.748-2.893",
    transform: "translate(-55.817 -1.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M220.3,15.59V12.842c0-3.472,2.1-5.642,5.786-5.642,3.472,0,5.642,2.1,5.642,5.425v.362h-3.11v-.362a2.267,2.267,0,0,0-2.531-2.459c-1.808,0-2.676,1.013-2.676,2.893V15.59c0,1.881.868,2.893,2.676,2.893a2.3,2.3,0,0,0,2.531-2.459v-.362h3.11v.217c0,3.327-2.17,5.425-5.642,5.425-3.689,0-5.786-2.17-5.786-5.714",
    transform: "translate(-60.964 -1.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M245.563,16.748v2.893h-1.88c-3.11,0-4.774-1.591-4.774-4.991V9.226H237.1V6.333h1.808V2.5h3.11V6.333h3.327V9.226h-3.327v4.846c0,1.881.8,2.748,2.314,2.748h1.23Z",
    transform: "translate(-65.613 -0.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M250.2,15.59V12.842c0-3.472,2.1-5.642,5.858-5.642,3.833,0,5.858,2.17,5.858,5.642V15.59c0,3.472-2.1,5.642-5.858,5.642-3.689.072-5.858-2.1-5.858-5.642m8.679-.072V12.986c0-1.881-.868-2.893-2.748-2.893s-2.748,1.013-2.748,2.893v2.531c0,1.881.868,2.893,2.748,2.893s2.748-1.013,2.748-2.893",
    transform: "translate(-69.238 -1.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M276.778,7.479v2.748a6.209,6.209,0,0,0-1.23-.217,2.822,2.822,0,0,0-3.038,2.965V21H269.4V7.7h2.1l.579,1.23a5.98,5.98,0,0,1,3.978-1.447,1.207,1.207,0,0,1,.723,0",
    transform: "translate(-74.551 -2.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M280.8,16.847v-.289h3.11v.289c0,1.085,1.013,1.736,2.531,1.736,1.23,0,2.17-.506,2.17-1.374,0-2.459-7.522-.8-7.522-5.642,0-2.6,2.1-4.267,5.208-4.267,3.255,0,5.208,1.808,5.208,4.34v.289H288.4V11.64c0-1.013-.868-1.591-2.17-1.591s-2.1.579-2.1,1.374c0,2.17,7.594.723,7.594,5.642,0,2.893-2.531,4.267-5.424,4.267-3.4,0-5.5-1.881-5.5-4.484",
    transform: "translate(-77.706 -2.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M308.4,13.381V5.931C308.4,2.314,311.077,0,315.634,0c4.629,0,7.305,2.314,7.305,5.931V7.377h-3.4V6.148c0-1.953-1.23-3.11-3.906-3.11s-4.05,1.157-4.05,3.11v7.016c0,1.953,1.3,3.11,4.05,3.11,2.676,0,3.906-1.157,3.906-3.11v-1.3h3.4v1.447c0,3.616-2.676,5.931-7.233,5.931s-7.305-2.314-7.305-5.858",
    transform: "translate(-85.344 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1240",
    "data-name": "Rectangle 1240",
    width: 3.11,
    height: 18.588,
    transform: "translate(239.91 0.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M339.6.5h3.182V3.827H339.6Zm.072,5.28h3.11V19.088h-3.11Z",
    transform: "translate(-93.978 -0.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M359.346,13.231V20.97h-3.11V13.158c0-2.025-1.085-3.038-2.676-3.038a2.578,2.578,0,0,0-2.748,2.6V20.97H347.7V7.662h2.025l.579,1.157A5.574,5.574,0,0,1,354.283,7.3c3.038,0,5.063,1.736,5.063,5.931",
    transform: "translate(-96.219 -2.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M367.2.5h3.182V3.827H367.2Zm.072,5.28h3.11V19.088h-3.11Z",
    transform: "translate(-101.615 -0.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M374.6,15.59V12.842c0-3.472,2.1-5.642,5.786-5.642,3.472,0,5.641,2.1,5.641,5.425v.362h-3.11v-.362a2.267,2.267,0,0,0-2.531-2.459c-1.808,0-2.676,1.013-2.676,2.893V15.59c0,1.881.868,2.893,2.676,2.893a2.3,2.3,0,0,0,2.531-2.459v-.362h3.11v.217c0,3.327-2.17,5.425-5.641,5.425-3.689,0-5.786-2.17-5.786-5.714",
    transform: "translate(-103.663 -1.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M58.457,40.759H57.68v3.456H56.9V35.575h1.987c1.9,0,2.937,1.037,2.937,2.419a3.116,3.116,0,0,1-3.369,2.764m.259-4.492H57.68v3.8c.259,0,.518.086.864.086,1.469,0,2.333-.778,2.333-1.987,0-1.3-.691-1.9-2.16-1.9",
    transform: "translate(-15.746 -9.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M68.195,45.008a6.586,6.586,0,0,1,.086-1.383,2.3,2.3,0,0,1-2.246,1.469,1.53,1.53,0,0,1-1.728-1.469c0-1.3,1.382-2.246,3.888-2.246v-.6c0-1.037-.346-1.642-1.469-1.642a3.7,3.7,0,0,0-1.9.519l-.087-.691a5.3,5.3,0,0,1,2.16-.518c1.642,0,2.16.864,2.16,2.073v4.406h-.864Zm0-3.024c-2.505,0-3.11.778-3.11,1.469a1.022,1.022,0,0,0,1.123,1.036,2.207,2.207,0,0,0,1.987-2.333Z",
    transform: "translate(-17.796 -10.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M75.844,39.3c-1.469-.259-2.16.95-2.16,3.11v2.505h-.778V38.612h.778a11.854,11.854,0,0,1-.173,1.642,2.148,2.148,0,0,1,2.333-1.814Z",
    transform: "translate(-20.176 -10.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M81.425,44.268c-1.209,0-1.555-.519-1.555-1.814V38.479H78.4v-.6H79.87v-2.16l.778-.259v2.333h1.987v.6H80.647v3.542c0,1.209.259,1.555,1.036,1.555a3.25,3.25,0,0,0,.95-.086v.691a6.736,6.736,0,0,1-1.209.173",
    transform: "translate(-21.696 -9.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M91.677,45.127c-1.641,0-2.764-1.036-2.764-3.283,0-1.814,1.036-3.283,2.937-3.283,1.469,0,2.764.778,2.764,3.2a2.938,2.938,0,0,1-2.937,3.369m.173-5.874c-1.036,0-2.074.778-2.074,2.591,0,1.642.778,2.678,2.074,2.678,1.036,0,1.987-.778,1.987-2.678,0-1.641-.691-2.591-1.987-2.591",
    transform: "translate(-24.605 -10.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M102.264,35.364a4.357,4.357,0,0,0-1.036-.173c-1.037,0-1.469.6-1.469,1.9v.432h1.987v.6H99.759v5.7h-.778v-5.7H97.513v-.6h1.468v-.432c0-1.814.864-2.591,2.333-2.591a4.216,4.216,0,0,1,1.036.086Z",
    transform: "translate(-26.985 -9.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M109.294,44.387a10.6,10.6,0,0,1-1.728-.173l.087-1.555a6.141,6.141,0,0,0,1.814.346c.864,0,1.468-.346,1.468-1.123,0-1.641-3.628-.864-3.628-3.715,0-1.555,1.209-2.591,3.283-2.591a9.563,9.563,0,0,1,1.555.172l-.087,1.469a4.886,4.886,0,0,0-1.555-.259c-.95,0-1.468.432-1.468,1.036,0,1.555,3.628.95,3.628,3.629,0,1.555-1.3,2.764-3.369,2.764",
    transform: "translate(-29.695 -9.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M118.684,45.127a2.135,2.135,0,0,1-.778-.087v3.024h-1.642v-9.33h1.555a4.219,4.219,0,0,1-.086,1.036,2.024,2.024,0,0,1,1.987-1.209c1.469,0,2.333,1.123,2.333,2.937,0,2.246-1.123,3.629-3.369,3.629m.6-5.184c-.864,0-1.382,1.036-1.382,2.074v1.728a2.672,2.672,0,0,0,.864.086c.95,0,1.555-.6,1.555-2.16,0-1.123-.345-1.728-1.036-1.728",
    transform: "translate(-32.174 -10.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M126.5,36.845a1.05,1.05,0,0,1-1.036-1.036,1.041,1.041,0,0,1,2.074,0,1.051,1.051,0,0,1-1.037,1.036m-.864.864h1.641v6.306h-1.641Z",
    transform: "translate(-34.719 -9.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M133.491,40.233c-1.209-.259-1.728.519-1.728,2.246v2.591h-1.641V38.764h1.555a6.953,6.953,0,0,1-.087,1.3,1.976,1.976,0,0,1,1.987-1.382Z",
    transform: "translate(-36.009 -10.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M140.786,42.07H136.9a1.516,1.516,0,0,0,1.728,1.728,4.318,4.318,0,0,0,1.815-.432l.172,1.3a6.474,6.474,0,0,1-2.246.433c-1.987,0-3.11-1.037-3.11-3.283,0-1.9,1.036-3.37,2.937-3.37a2.584,2.584,0,0,1,2.678,2.851,2.381,2.381,0,0,1-.087.778m-2.591-2.333c-.691,0-1.123.519-1.209,1.3h2.333c0-.864-.432-1.3-1.123-1.3",
    transform: "translate(-37.43 -10.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M153.308,44.214V40.5h-3.629v3.715h-1.641V35.575h1.641V39.03h3.629V35.575h1.641v8.639Z",
    transform: "translate(-40.967 -9.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M164.795,42.07h-3.888a1.516,1.516,0,0,0,1.728,1.728,4.314,4.314,0,0,0,1.814-.432l.173,1.3a6.479,6.479,0,0,1-2.246.433c-1.987,0-3.109-1.037-3.109-3.283,0-1.9,1.036-3.37,2.936-3.37a2.584,2.584,0,0,1,2.678,2.851,2.4,2.4,0,0,0-.086.778m-2.678-2.333c-.692,0-1.124.519-1.21,1.3h2.333c0-.864-.432-1.3-1.123-1.3",
    transform: "translate(-44.074 -10.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M171.7,45.04A3.852,3.852,0,0,1,171.787,44a2.258,2.258,0,0,1-1.987,1.209,1.638,1.638,0,0,1-1.815-1.641c0-1.555,1.469-2.333,3.629-2.333v-.346c0-.691-.346-1.036-1.209-1.036a3.7,3.7,0,0,0-1.9.518l-.173-1.382a6.124,6.124,0,0,1,2.246-.432c2.073,0,2.591.864,2.591,2.246v4.32H171.7Zm-.086-2.764c-1.728,0-2.074.519-2.074,1.036,0,.433.26.691.778.691a1.52,1.52,0,0,0,1.382-1.555v-.173Z",
    transform: "translate(-46.486 -10.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1241",
    "data-name": "Rectangle 1241",
    width: 1.641,
    height: 9.33,
    transform: "translate(128.237 25.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M183.464,44.234c-1.382,0-1.814-.519-1.814-1.987v-3.2h-1.123v-1.3h1.123V35.768l1.641-.432v2.419h1.555v1.3h-1.555v2.765c0,.778.173,1.036.778,1.036a2.381,2.381,0,0,0,.778-.087v1.3a3.8,3.8,0,0,1-1.382.173",
    transform: "translate(-49.957 -9.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M191.821,43.95V39.89c0-.691-.173-1.036-.778-1.036-.864,0-1.469.95-1.469,2.073V43.95h-1.641V34.62h1.641V37.3a6.554,6.554,0,0,1-.086,1.3,2.3,2.3,0,0,1,2.074-1.209,1.746,1.746,0,0,1,1.9,1.987v4.493h-1.641Z",
    transform: "translate(-52.007 -9.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M199.861,45.127c-1.728,0-2.851-.95-2.851-3.11,0-1.987,1.037-3.456,3.283-3.456a6.7,6.7,0,0,1,1.3.173l-.173,1.382a5.3,5.3,0,0,0-1.123-.259c-1.036,0-1.555.778-1.555,1.987,0,1.123.432,1.814,1.469,1.814a2.759,2.759,0,0,0,1.209-.259l.086,1.382a3.082,3.082,0,0,1-1.641.346",
    transform: "translate(-54.518 -10.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M208.012,45.04A3.883,3.883,0,0,1,208.1,44a2.257,2.257,0,0,1-1.987,1.209,1.638,1.638,0,0,1-1.814-1.641c0-1.555,1.468-2.333,3.628-2.333v-.346c0-.691-.345-1.036-1.209-1.036a3.7,3.7,0,0,0-1.9.518l-.172-1.382a6.121,6.121,0,0,1,2.246-.432c2.074,0,2.591.864,2.591,2.246v4.32h-1.468Zm-.173-2.764c-1.728,0-2.074.519-2.074,1.036,0,.433.26.691.778.691a1.52,1.52,0,0,0,1.382-1.555v-.173Z",
    transform: "translate(-56.535 -10.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M216.983,40.233c-1.209-.259-1.728.519-1.728,2.246v2.591h-1.641V38.764h1.555a6.952,6.952,0,0,1-.087,1.3,1.976,1.976,0,0,1,1.987-1.382Z",
    transform: "translate(-59.113 -10.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M224.278,42.07h-3.888a1.516,1.516,0,0,0,1.728,1.728,4.314,4.314,0,0,0,1.814-.432l.173,1.3a6.482,6.482,0,0,1-2.246.433c-1.987,0-3.11-1.037-3.11-3.283,0-1.9,1.037-3.37,2.937-3.37a2.584,2.584,0,0,1,2.678,2.851,2.4,2.4,0,0,1-.086.778M221.6,39.737c-.691,0-1.123.519-1.209,1.3h2.333c0-.864-.432-1.3-1.123-1.3",
    transform: "translate(-60.534 -10.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M.147,31.2A14.775,14.775,0,0,0,9.16,34.283a9.512,9.512,0,0,0,8.268-4.056A9.511,9.511,0,0,0,25.7,34.283,14.77,14.77,0,0,0,34.708,31.2l-2.048-3.864s-.434.345-.7.534a10.874,10.874,0,0,1-6.222,2.154c-2.985,0-5.238-1.862-5.238-4.408,0-2.057,1.568-4.115,4.408-5.778l3.623-2.2c4.507-2.694,6.32-5.192,6.32-8.767C34.855,3.624,30.837,0,25.011,0a13.375,13.375,0,0,0-7.583,2.281A13.382,13.382,0,0,0,9.845,0C4.016,0,0,3.624,0,8.864c0,3.575,1.813,6.073,6.32,8.767l3.624,2.2c2.84,1.664,4.408,3.721,4.408,5.778,0,2.547-2.254,4.408-5.24,4.408a10.875,10.875,0,0,1-6.22-2.154c-.259-.189-.694-.534-.694-.534ZM12.736,15.918,9.062,13.762C5.781,11.8,4.41,10.186,4.41,8.178c0-2.253,2.2-3.87,5.338-3.87,4.051,0,7.684,3.367,7.684,3.367s3.517-3.367,7.673-3.367c3.137,0,5.341,1.617,5.341,3.87,0,2.008-1.372,3.624-4.654,5.584L22.12,15.918a13.16,13.16,0,0,0-4.692,4.27,13.166,13.166,0,0,0-4.692-4.27",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9747434398fd95705a2172eb91755823.svg";
export { ForwardRef as ReactComponent };